import { PageWrapper, Tabs } from '@welbe/web-design-system';
import userIcon from 'App/assets/img/add_user.svg?url';
import { ReactComponent as Bag } from 'App/assets/img/bag.svg';
import { ReactComponent as Heart } from 'App/assets/img/heart.svg';
import { Fragment, useMemo, useState } from 'react';
import { Admin } from './Admin/Admin';
import { Doctor } from './Doctor/Doctor';

export const Users = (): JSX.Element => {
	const [active, setActive] = useState<number>(0);

	const tabs = [
		{
			name: 'Administrativo',
			icon: <Bag />,
		},
		{
			name: 'Personal médico',
			icon: <Heart />,
		},
	];

	const onChangeTab = (tabNumber: number) => {
		setActive(tabNumber);
	};

	const components = useMemo(
		() => [
			{
				id: 0,
				content: <Admin />,
			},
			{
				id: 1,
				content: <Doctor />,
			},
		],
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[active],
	);

	return (
		<PageWrapper
			icon={
				<img
					src={userIcon}
					alt="User icon"
					width="30px"
					height="30px"
					color="#b2b6c0"
				/>
			}
			title="Gestión de accesos"
		>
			<Fragment>
				<Tabs
					initialActiveTab={active}
					side="right"
					tabItems={tabs}
					onChange={onChangeTab}
					height="100%"
					width="100%"
					overflow="hidden"
					className="tabs-container"
				/>
				{components[active].content}
			</Fragment>
		</PageWrapper>
	);
};
